import React from "react";
import AsyncSelect from "react-select/async";
import { useFilterContext, filterVideosByCategory } from "../context/FilterProvider";
import styled from "styled-components";

export default function Filter({ cats, history, location }) {
	const [state, dispatch] = useFilterContext();
	const { filter, allCats, results } = state;
	const activateFilter = async (e) => {
		const selected = e.target.innerHTML;
	};

	const updateFilters = async (e, v) => {
		const selected = e.value;
		if (selected === null) {
			return;
		}

		if (selected === "") {
			console.log("selected", selected);
			dispatch({ type: "UPDATE_FILTER", payload: results });
			return { value: e.value, label: e.label };
		}

		const filteredVideos = filterVideosByCategory(results, selected);
		dispatch({ type: "UPDATE_FILTER", payload: filteredVideos });
		return { value: e.value, label: e.label };
	};

	const getCatsArray = (cats) => {
		let result = [{ label: "All", value: "" }];
		cats.map((cat) => {
			result.push({ label: cat.name, value: cat.slug });
		});
		return result;
	};

	return (
		<StyledFilters>
			{cats && (
				<div>
					{cats.map((single) => (
						<button
							type="button"
							onClick={activateFilter}
							className={filter === single ? "active" : ""}
							key={single}
						>
							{single}
						</button>
					))}
				</div>
			)}
			<div>
				{allCats && allCats.length > 0 && (
					<AsyncSelect
						id="category"
						name="category"
						onChange={updateFilters}
						defaultOptions={getCatsArray(allCats)}
						styles={customStyles}
						placeholder="Filter"
						menuColor="red"
					/>
				)}
			</div>
		</StyledFilters>
	);
}

const StyledFilters = styled.section`
	z-index: 100;
`;

const customStyles = {
	container: (provided, state) => {
		const zIndex = "1000";

		return { ...provided, zIndex, color: "white" };
	},
	menu: (provided, state) => ({
		...provided,
		borderBottom: "1px dotted pink",
		color: "#8865AB",
	}),

	control: (provided, state) => ({
		...provided,
		backgroundColor: "#8865AB",
		color: "white",
		borderRadius: 0,
		border: "none",
		padding: 1,
	}),

	placeholder: (provided, state) => ({
		...provided,
		color: "white",
		fontSize: 18,
	}),

	dropdownIndicator: (provided, state) => ({
		...provided,
		color: "white",
	}),

	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = "opacity 300ms";

		return { ...provided, opacity, transition, color: "white" };
	},
};
